import { CoverageMonitor as CoverageMonitorType } from "@redotech/redo-return-coverage-common/coverage-monitor";
import { RedoButton } from "@redotech/redo-web/arbiter-components/buttons/redo-button";
import * as gridCss from "@redotech/redo-web/grid.module.css";
import { getDateTimeString } from "@redotech/util/date-format";
import { Fragment, memo } from "react";
import * as teamCss from "../../../../team.module.css";

export const CoverageMonitorSettings = memo(function CoverageMonitorSettings({
  coverageMonitor,
  onButtonClick,
}: {
  coverageMonitor: CoverageMonitorType;
  onButtonClick: () => void;
}) {
  if (!coverageMonitor?.current) {
    return <> </>;
  }

  const unprotectedBase = coverageMonitor?.baseline?.[0];
  const protectedBase = coverageMonitor?.baseline?.[1];

  // let currentValues = Object.values(coverageMonitor.current).filter(Array.isArray);
  const currentValuesTitles: string[] = [];
  const currentValuesMessages: [string][] = [];
  for (const [key, value] of Object.entries(coverageMonitor.current)) {
    if (value) {
      currentValuesTitles.push("Most Recent " + key + " Orders");
      let currentPercentage: string | number = "Uncalculated";
      const protectedCurrent = value[1];
      const unprotectedCurrent = value[0];
      if (protectedCurrent && unprotectedCurrent) {
        currentPercentage =
          protectedCurrent / (protectedCurrent + unprotectedCurrent);
      }
      currentValuesMessages.push(["Percent Attachment: " + currentPercentage]);
    }
  }

  let historicalPercentage: string | number = "Uncalculated";
  if (protectedBase && unprotectedBase) {
    historicalPercentage = protectedBase / (protectedBase + unprotectedBase);
  }

  const alertValue = coverageMonitor?.alertAt;
  let formattedAlertValue = "";
  if (alertValue) {
    formattedAlertValue = getDateTimeString(new Date(alertValue));
  }

  let alertMessage = "";
  if (alertValue) {
    alertMessage = "Alert Activated At: " + formattedAlertValue;
  } else {
    alertMessage = "Alert Off";
  }

  return (
    <section className={gridCss.grid}>
      <div className={gridCss.span12}>
        <dl className={teamCss.table}>
          <dt className={teamCss.tableHeader}>Alert</dt>
          <dd className={teamCss.tableCell}>{alertMessage}</dd>
          <dt className={teamCss.tableHeader}>Historical</dt>
          <dd className={teamCss.tableCell}>
            {coverageMonitor?.baseline &&
              "Percent Attachment: " + historicalPercentage}
          </dd>
          {currentValuesTitles.map((title, index) => (
            <Fragment key={title}>
              <dt className={teamCss.tableHeader}>{title}</dt>
              <dd className={teamCss.tableCell}>
                {/* @ts-expect-error TODO: noUncheckedIndexedAccess FIXME */}
                {currentValuesMessages[index].join("\n")}
              </dd>
            </Fragment>
          ))}
        </dl>
      </div>
      <div className={gridCss.span12}>
        <RedoButton
          hierarchy="secondary"
          onClick={() => {
            onButtonClick();
          }}
          size="md"
          text="Reset Alert"
          theme="normal"
        />
      </div>
    </section>
  );
});
